import classNames from 'classnames';
import { ButtonHTMLAttributes, FC, PropsWithChildren } from 'react';

import css from './button.module.scss';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement>, PropsWithChildren {
  className?: string;
  isBorder?: boolean;
  isMaxWidth?: boolean;
  isWidthMdExtra?: boolean;
  isMarginAuto?: boolean;
}

const Button: FC<Props> = ({
  className,
  children,
  isBorder = false,
  isMaxWidth = false,
  isWidthMdExtra = false,
  isMarginAuto = false,
  type = 'button',
  ...rest
}) => {
  return (
    <button
      type={type}
      className={classNames(
        css.button,
        'button',
        {
          [css.button_border]: isBorder,
          [css.button_widthMax]: isMaxWidth,
          [css.button_widthMdExtra]: isWidthMdExtra,
          [css.button_marginAuto]: isMarginAuto,
        },
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
